import {
    MY_SALES_DETAILS_EXECUTIVE,
    MY_SALES_DETAILS_EXECUTIVE_ERROR,
    CLEAN_MY_SALES_DETAILS_EXECUTIVE,
    CLEAN_MY_SALES_DETAILS_EXECUTIVE_ERROR,
} from "_models/redux/types";

const initialState = {
    loaded: undefined,
    method: undefined,
    payload: undefined,
    status: undefined,
    state: undefined,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case MY_SALES_DETAILS_EXECUTIVE:
            return {
                ...state,
                loaded: true,
                method: action?.method || null,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "success",
            };

        case MY_SALES_DETAILS_EXECUTIVE_ERROR:
            return {
                ...state,
                loaded: true,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "error",
            };

        case CLEAN_MY_SALES_DETAILS_EXECUTIVE:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "success",
            };

        case CLEAN_MY_SALES_DETAILS_EXECUTIVE_ERROR:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "error",
            };
        default:
            return state;
    }
}
